var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-caption d-flex gap-1"},_vm._l((_vm.getItemStatusInfo(_vm.item)),function(ref,index){
var icon = ref.icon;
var color = ref.color;
var label = ref.label;
var value = ref.value;
return _c('v-tooltip',{key:index,attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({staticClass:"d-flex"},'span',attrs,false),on),[_c('v-icon',{staticClass:"mr-1",attrs:{"size":"16","color":color}},[_vm._v(_vm._s(icon))]),_vm._v(" "+_vm._s(value)+" ")],1)]}}],null,true)},[_vm._v(" "+_vm._s(label)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }